import "@lottiefiles/lottie-player";
import {setHeaderHeight} from "./modules/setHeaderHeight.js";

import.meta.glob([
	'../images/**',
	'../fonts/**',
]);

const loadIfPresent = (selector, callback) => {
	if (document.querySelector(selector)) {
		callback();
	}
};

document.addEventListener('DOMContentLoaded', function () {
	setHeaderHeight();

	loadIfPresent('.wp-block-acf-accordion', async () => {
		const {blockAccordion} = await import("./blocks/accordions.js");
		blockAccordion();
	});
}, false);